import { CAPTION_SETTINGS } from '../../services/consts';
import { getCaptionSettingsList } from '../getCaptionSettingsList/getCaptionSettingsList';

export async function getTextStyle() {
  const textStyle = localStorage.getItem(CAPTION_SETTINGS);

  if (textStyle) {
    return JSON.parse(textStyle);
  }

  const [defaultItem] = getCaptionSettingsList();

  localStorage.setItem(CAPTION_SETTINGS, JSON.stringify(defaultItem));

  return defaultItem;
}
